import { GMResolutionsDeleteRequest } from '@/dtos/resolutions/gm-resolution/delete'

export class GMResolutionsDraftDeleteRequest extends GMResolutionsDeleteRequest {}
